import './src/styles/index.scss';
import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import ArticleCard from './src/components/ArticleCard/ArticleCard';
import ResourceCard from './src/components/ResourceCard/ResourceCard';

// wrapPageElement runs per-page, inside the theme's wrapRootElement MDXProvider.
// Our MDXProvider is the innermost one so its overrides win (inner beats outer).
// Both ArticleCard (Videos) and ResourceCard (Articles & blogs) need target="_blank"
// for external links — they are separate components in gatsby-theme-carbon.
const overrides = { ArticleCard, ResourceCard };

export const wrapPageElement = ({ element }) => (
  <MDXProvider components={overrides}>{element}</MDXProvider>
);
